var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-tabs",
    { attrs: { "content-class": "mt-3" } },
    [
      _c(
        "b-tab",
        { attrs: { title: "Bills", active: "" } },
        [_c("bills", { attrs: { bills: _vm.bills } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-tab",
        { attrs: { title: "Payments" } },
        [
          _c("bill_payments_table", {
            attrs: { payments: _vm.billing_data.payments },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }